import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChartConfiguration, ChartData } from 'chart.js';
import { KpiAlarmCoverageDataPoint } from '../../models/kpi-snapshot.model';
import { KpiFilters } from '../../models/kpi-filters.model';
import { KpiService } from '../../services/kpi.service';

@Component({
  selector: 'app-kpi-alarm-coverage',
  templateUrl: './kpi-alarm-coverage.component.html',
  styleUrl: './kpi-alarm-coverage.component.scss',
  standalone: false,
})
export class KpiAlarmCoverageComponent implements OnChanges {
  @Input() filters: KpiFilters = {};

  loading = false;

  chartData: ChartData<'bar'> = {
    labels: [],
    datasets: [
      {
        label: 'Règles avec alarme active',
        data: [],
        backgroundColor: '#ef4444',
      },
      {
        label: 'Règles sans alarme',
        data: [],
        backgroundColor: '#94a3b8',
      },
    ],
  };

  chartOptions: ChartConfiguration<'bar'>['options'] = {
    responsive: true,
    plugins: { legend: { position: 'top' } },
    scales: {
      x: { stacked: true },
      y: { stacked: true, beginAtZero: true },
    },
  };

  constructor(private kpiService: KpiService) {}

  ngOnChanges(_changes: SimpleChanges): void {
    this.load();
  }

  private load(): void {
    this.loading = true;
    this.kpiService.getAlarmCoverage(this.filters).subscribe({
      next: (response) => {
        this.chartData = {
          labels: response.dataPoints.map((p) =>
            new Date(p.snapshotDate).toLocaleDateString(),
          ),
          datasets: [
            {
              label: 'Règles avec alarme active',
              data: response.dataPoints.map((p) => p.rulesWithActiveAlarm),
              backgroundColor: '#ef4444',
            },
            {
              label: 'Règles sans alarme',
              data: response.dataPoints.map(
                (p) => p.totalRules - p.rulesWithActiveAlarm,
              ),
              backgroundColor: '#94a3b8',
            },
          ],
        };
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }
}
